module.exports = __webpack_public_path__ + "static/media/Top_4_reasons_to_work_with_a_property_manager.8fe3b150.pdf";